import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BasePage } from '../../base-page';

@Component({
  selector: 'app-edit-store',
  templateUrl: './edit-store.component.html',
  styleUrls: ['./edit-store.component.scss'],
  standalone: false
})
export class EditStoreComponent extends BasePage implements OnInit {

  private mRouter = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  public storeId?: string;

  constructor() {
    super();
    this.storeId = this.activatedRoute.snapshot.params['id'] !== 'new' ? this.activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {
    // Component initialization
  }

  public override back() {
    this.mRouter.navigate(['/stores/list']);
  }
}
